export default initData => {
    return {
        gpt: 'gptData' in initData ? initData.gptData : null,
        adSenseQuery: '',
        adSenseShoppingPublisherId: ''
    };
};
